import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { APICallService } from 'src/app/services/api-call.service';
import { AppMessageService } from 'src/app/services/app-message.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { SecurityService } from 'src/app/services/security.service';
import { UserDetailsService } from 'src/app/services/user-details.service';

@Component({
  selector: 'project-lov',
  templateUrl: './project-lov.component.html',
  styleUrls: ['./project-lov.component.css']
})
export class ProjectLovComponent implements OnInit {

  private projectModuleId: string = 'BMM059';
  private selectedData: any;
  public titleLov: string = "Project".toUpperCase();

  projectTable: any = {
    cols: [
      {
        key: "PROJECT_CD",
        header: "Project Code",
        dataType: "string"
      },
      {
        key: "PROJECT_DESC",
        header: "Project Name",
        dataType: "string"
      },
    ],
    tblData: [],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15,
    loading: false,
  };

  constructor(
    private jsonDataService: JsonDataService,
    private dialogRef: MatDialogRef<ProjectLovComponent>,
    private _api: APICallService,
    private securityService: SecurityService,
    private appMessageService: AppMessageService,
    private userDetailService: UserDetailsService,
    @Inject(MAT_DIALOG_DATA) public fromMainData: any,
  ) {
    this.getProjectData();
  }

  ngOnInit(): void {
  }

  onRowClick(ev: any) {
    try {
      this.selectedData = ev;
    } catch (e) {
    console.error(e);

    }
  }

  private getProjectData(): void {
    try {
      this.projectTable.loading = true;
      this.jsonDataService.contorlLoading(true);
      this._api.getProject({
        lineCd: this.fromMainData.lineCd,
        moduleId: this.fromMainData.moduleId,
        userId: this.userDetailService.userId,
        type: "LOV"
      }).subscribe({
        next: (response: any) => {
          this.securityService.checkRequestKeyResponse(response, () => {
            this.securityService.hasValidCsrfToken(response, () => {
              let content = JSON.parse(this.jsonDataService.decrypt(response.response));
              if (content.moduleId === this.projectModuleId) {
                this.jsonDataService.contorlLoading(false);
                this.projectTable.tblData = content.data.filter((e: any) => e.ACTIVE_TAG == 'A');
                this.projectTable.loading = false;
              } else {
                this.projectTable.loading = false;
                this.jsonDataService.contorlLoading(false);
                this.appMessageService.showAppMessage("You do not have the correct privilege to access the data. Kindly contact your administrator for assistance.", "error");
              }
            });
          });
        },
        error: (e: any) => {
          this.securityService.checkRequestKeyResponse(e, () => {

            this.projectTable.loading = false;
            this.jsonDataService.contorlLoading(false);
            this.appMessageService.showAppMessage(e, "error");
          });
        }
      });
    }
    catch (e) {
    console.error(e);

      this.projectTable.loading = false;
      this.jsonDataService.contorlLoading(false);
    }
  }

  onClose(str: string) {
    try {
      if (this.selectedData == '' || this.selectedData == null) {
        this.dialogRef.close({ content: '', button: str });
      }
      else {
        this.dialogRef.close({ content: this.selectedData, button: str });
      }
    } catch (e) {
    console.error(e);

    }
  }

}
